<template lang="html">
  
    <div  v-if="review != null">
        <div class="block" v-if="can_use_as_example">
        <label class="checkbox">
            <input type="checkbox"
                   v-model="use_as_logos_example"
                   @change="update_use_as_logos_example"/>
            Utiliser comme exemple dans Logos ?
        </label>
        </div>
        <div v-if="answers">
            <div v-for="answer of answers"
                 :key="answer.uid + '-' + single_answer_key">
                <div class="card border mt-1 mb-2 ">
                    <div class="card-body p-2">
                        <LogosSingleAnswer :key="answer.uid + '-' + single_answer_key"
                                           :answer="answer"
                                           :can_improve_answer="can_generate_new_answer"
                                           :has_game_set="review.has_game_set"
                                           :game_set="review.game_set"
                                           @scores-saved="fetch_scores_progress"
                                           @trigger-fetch-review="fetch_review"
                                           @trigger-fetch-answers="fetch_answers">
                        </LogosSingleAnswer>
                    </div>
                </div>
            </div>
        </div>
        <LogosAdditionalAnswer v-if="can_generate_new_answer &amp;&amp; answers.length &lt; 3"
                               :review="review"
                               :answers="answers"
                               @trigger-fetch-answers="fetch_answers"
                               @trigger-fetch-review="fetch_review">
        </LogosAdditionalAnswer>

    </div>
</template>


<script>
import REVIEW_SET_USE_AS_EXAMPLE from '@/gql/mutations/reviewSetUseAsExample.graphql'
import REVIEW_ENSURE_ALL_GAMES from '@/gql/mutations/reviewEnsureAllGames.graphql'
import REVIEW_GENERATE_LOGOS_ANSWER from '@/gql/mutations/reviewGenerateLogosAnswer.graphql'
import ANSWER_SET from '@/gql/queries/answerSet.graphql'
import REVIEW_DETAIL from '@/gql/queries/reviewDetail.graphql'
import REVIEW_CAN_BE_USED_AS_LOGOS_EXAMPLE from '@/gql/queries/reviewCanBeUsedAsLogosExample.graphql'
import REVIEW_SCORES_PROGRESS from '@/gql/queries/reviewScoresProgress.graphql'
import ASSISTANTS from '@/gql/queries/assistants.graphql'
import { gqlQuery, gqlMutation } from '@/gqlClient.js'
import moment from "moment"
import utils from '@/utils.js'


import LogosSingleAnswer from '@/components/LogosSingleAnswer'
import LogosAdditionalAnswer from '@/components/LogosAdditionalAnswer'

moment.locale("fr")

export default {
  name: "LogosAnswer",
  components: {
    LogosSingleAnswer,
    LogosAdditionalAnswer
  },
  data() {
    return {
      answers: [],
      review: null,
      error: null,
      height: "800px",
      generating: false,
      can_use_as_example: false,
      use_as_logos_example: false,
      answers_with_scores: null,
      total_answers_for_etab_and_sentiment: null,
      scores_progress_ratio: null,
      can_generate_new_answer: false,
      single_answer_key: 0
    };
  },
  watch: {
    "$store.state.selected_review_uid": async function (old_value, new_value) {
      if (old_value !== new_value) {
        this.error = null;
        await Promise.all([
          this.fetch_answers(),
          this.fetch_review(),
          this.fetch_scores_progress(),
        ]);
        this.use_as_logos_example = this.review ? this.review.use_as_logos_example : false;
      }
    }
  },
  computed: {
    component_style() {
      return {
        height: this.height,
        "overflow-y": "scroll"
      };
    }
  },
  methods: {
    reload_answers() {
      this.single_answer_key += 1;
    },
    async update_use_as_logos_example(event) {
      const new_value = event.target.checked;
      const response = await gqlMutation(REVIEW_SET_USE_AS_EXAMPLE, { uid: this.$store.state.selected_review_uid, value: new_value });
      if (response.ok) {
        this.use_as_logos_example = new_value;
      }
    },
    async generate_answer() {
      this.generating = true;
      const response = await gqlMutation(REVIEW_GENERATE_LOGOS_ANSWER, { uid: this.$store.state.selected_review_uid });
      if (response.ok) {
        if (response.body.data.review_generate_logos_answer.ok) {
          await this.fetch_answers();
          this.error = null;
        } else {
          this.error = response.body.data.review_generate_logos_answer.msg;
        }
      } else {
        this.error = response.body.data;
      }
      this.generating = false;
    },
    human_datetime(value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    async fetch_answers() {
      if (this.$store.state.selected_review_uid) {
        await gqlMutation(REVIEW_ENSURE_ALL_GAMES, { uid: this.$store.state.selected_review_uid });
        const response = await gqlQuery(ANSWER_SET, { review_uid: this.$store.state.selected_review_uid });
        if (response.ok) {
          this.answers = response.body.data.answer_set;
        } else {
          this.answers = [];
        }
      }
      this.reload_answers();
    },
    async fetch_review() {
      this.review = null;
      this.use_as_logos_example = false;
      if (this.$store.state.selected_review_uid) {
        const [response, response2] = await Promise.all([
          gqlQuery(REVIEW_DETAIL, { uid: this.$store.state.selected_review_uid }),
          gqlQuery(REVIEW_CAN_BE_USED_AS_LOGOS_EXAMPLE, { uid: this.$store.state.selected_review_uid }),
        ]);
        if (response.ok) {
          this.review = response.body.data.review;
          this.use_as_logos_example = this.review.use_as_logos_example;
        }
        if (response2.ok) {
          this.can_use_as_example = response2.body.data.review_can_be_used_as_logos_example.can_use_as_example;
        }
      }
      this.reload_answers();
    },
    async fetch_scores_progress() {
      if (this.$store.state.selected_review_uid) {
        const response = await gqlQuery(REVIEW_SCORES_PROGRESS, { uid: this.$store.state.selected_review_uid });
        if (response.ok) {
          this.answers_with_scores = response.body.data.review_scores_progress.answers_with_scores;
          this.total_answers_for_etab_and_sentiment = response.body.data.review_scores_progress.total_answers_for_etab_and_sentiment;
          this.scores_progress_ratio = response.body.data.review_scores_progress.scores_progress_ratio;
        }
      }
    },
    set_height() {
      utils.debounce(() => {
        this.height = (window.innerHeight - 65) + "px";
      }, 500)();
    },
    async fetch_assistants() {
      const resp = await gqlQuery(ASSISTANTS, { tags: ["reviews"] });
      if (resp.ok) {
        this.assistants = resp.body.data.assistants;
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.fetch_answers(),
      this.fetch_review(),
      this.fetch_scores_progress(),
    ]);
    this.set_height();
    window.addEventListener('resize', this.set_height);
    this.can_generate_new_answer = this.$store.state.profile.permissions.includes("game.can_generate_answer");
  }
}
</script>

<style lang="scss" scoped>

</style>
